import { z } from "zod";

const envSchema = z.object({
  VITE_TELEMETRY_ENABLED: z
    .enum(["true", "false"])
    .default("true")
    .transform((value) => value === "true"),
  VITE_APP_VERSION: z
    .string()
    .regex(/^[a-zA-Z0-9._-]{1,64}$/)
    .default("0.1.0"),
  VITE_API_BASE_URL: z.url().default("http://localhost:5132"),
});

const parsedEnv = envSchema.safeParse(import.meta.env);

if (!parsedEnv.success) {
  throw new Error(
    `Invalid application environment: ${z.prettifyError(parsedEnv.error)}`,
  );
}

/** Validated public runtime configuration compiled into the browser bundle. */
export const env = parsedEnv.data;
